export default __webpack_public_path__ + "fd506233c4a89be167ed2ee86e88be29.png";